import { SupportedAudioFormat } from './types';

export const supportedAudioFormats: SupportedAudioFormat[] = [
  {
    mimeType: 'audio/webm;opus',
    encoding: 'opus',
    extension: 'webm',
  },
  {
    mimeType: 'audio/mp4;codecs="mp4a.40.2"',
    encoding: 'aac',
    extension: 'mp4',
  },
  {
    mimeType: 'audio/mpeg',
    encoding: 'mp3',
    extension: 'mp3',
  },
  {
    mimeType: 'audio/mp4',
    encoding: 'mp4',
    extension: 'mp4',
  },

  {
    mimeType: 'audio/wav',
    encoding: 'wav',
    extension: 'wav',
  },

  {
    mimeType: 'audio/x-m4a',
    encoding: 'aac',
    extension: 'm4a',
  },
];

export const getSupportedAudioFormat = () => {
  const supportedFormat = supportedAudioFormats.find((audioFormat) =>
    MediaRecorder.isTypeSupported(audioFormat.mimeType),
  );

  if (!supportedFormat) {
    throw new Error('No supported audio format found');
  }

  return supportedFormat;
};
